/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/InvoicingDataLightReportPaginationSlice'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./InvoicingDataLightReportPaginationSlice'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.MapRegionDataReport = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.InvoicingDataLightReportPaginationSlice);
  }
}(this, function(ApiClient, InvoicingDataLightReportPaginationSlice) {
  'use strict';




  /**
   * The MapRegionDataReport model module.
   * @module model/MapRegionDataReport
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>MapRegionDataReport</code>.
   * @alias module:model/MapRegionDataReport
   * @class
   */
  var exports = function() {
    var _this = this;







  };

  /**
   * Constructs a <code>MapRegionDataReport</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/MapRegionDataReport} obj Optional instance to populate.
   * @return {module:model/MapRegionDataReport} The populated <code>MapRegionDataReport</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('Value')) {
        obj['Value'] = ApiClient.convertToType(data['Value'], 'Number');
      }
      if (data.hasOwnProperty('Invoices')) {
        obj['Invoices'] = InvoicingDataLightReportPaginationSlice.constructFromObject(data['Invoices']);
      }
      if (data.hasOwnProperty('CountryIso3166')) {
        obj['CountryIso3166'] = ApiClient.convertToType(data['CountryIso3166'], 'String');
      }
      if (data.hasOwnProperty('Name')) {
        obj['Name'] = ApiClient.convertToType(data['Name'], 'String');
      }
      if (data.hasOwnProperty('GeoJSON')) {
        obj['GeoJSON'] = ApiClient.convertToType(data['GeoJSON'], Object);
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Number} Value
   * @default 0.0
   */
  exports.prototype['Value'] = 0.0;
  /**
   * @member {module:model/InvoicingDataLightReportPaginationSlice} Invoices
   */
  exports.prototype['Invoices'] = undefined;
  /**
   * @member {String} CountryIso3166
   * @default ''
   */
  exports.prototype['CountryIso3166'] = '';
  /**
   * @member {String} Name
   * @default ''
   */
  exports.prototype['Name'] = '';
  /**
   * @member {Object} GeoJSON
   */
  exports.prototype['GeoJSON'] = undefined;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


